import { useQuery } from "@tanstack/react-query";
import { makeAuthedRequest } from "shared/api/authRequest";

// Standalone fetcher so it can be reused outside React hooks (e.g., in loaders)
export const getUserMe = async () => {
  const result = await makeAuthedRequest<any>({
    method: "get",
    url: `/api/ConnectUsers/me`,
  });
  return result;
};

export default function useGetUser(enabled?: boolean) {
  return useQuery({
    queryKey: ["user", "me"],
    queryFn: getUserMe,
    enabled: enabled ?? true,
  });
}
